import * as Yup from 'yup';
import editTipoNOvedadFormModel from './editNovedadesTurnoFormModel';

const {
  formField: {
    e_colaborador,
    e_responsable,
    e_tipoNovedad,
    e_fechaNovedad,
    e_horaNovedad,
    e_description,
  },
} = editTipoNOvedadFormModel;

export default [
  Yup.object().shape({
    [e_colaborador.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${e_colaborador.requiredErrorMsg}`),
    [e_responsable.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${e_responsable.requiredErrorMsg}`),
    [e_tipoNovedad.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${e_tipoNovedad.requiredErrorMsg}`),
    [e_fechaNovedad.name]: Yup.string().required(`${e_fechaNovedad.requiredErrorMsg}`),
    [e_horaNovedad.name]: Yup.string().required(`${e_horaNovedad.requiredErrorMsg}`),
    [e_description.name]: Yup.string().required(`${e_description.requiredErrorMsg}`),
  }),
];
